<app-editable-grid #wasteGrid [data]="model.wastesArrival" entityName="VesselNotificationWaste" [canAddNew]="canAddNew" [canEdit]="canEdit" [editMode]="editMode">
    <kendo-grid-column title="{{'Waste Type' | translate}}" [width]="320" field="wasteTypeId">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control type="codelist" codelist="WasteType" [disableTooltip]="true"
                [(ngModel)]="dataItem.wasteTypeId" [entity]="dataItem" property="wasteTypeId"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.wasteTypeId | codelist:'WasteType' | async}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{'Description' | translate}}" [width]="200" field="description">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control [disableTooltip]="true"
                [(ngModel)]="dataItem.description" [entity]="dataItem" property="description"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{defaultDisplayValue(dataItem.description, 'string')}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{'Waste to be delivered (m3) - Malta' | translate}}" field="wasteToBeDelivered">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control name="wasteToBeDelivered" type="number" format="n3" [decimals]="3"
                [disableTooltip]="true" [(ngModel)]="dataItem.wasteToBeDelivered" [entity]="dataItem" property="wasteToBeDelivered"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{defaultDisplayValue(dataItem.wasteToBeDelivered, 'number') | number:'.3-3'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{'Max dedicated storage (m3)' | translate}}" field="wasteMaximumCapacity">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control type="number" format="n3" [decimals]="3"
                [disableTooltip]="true" [(ngModel)]="dataItem.wasteMaximumCapacity" [entity]="dataItem" property="wasteMaximumCapacity"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{defaultDisplayValue(dataItem.wasteMaximumCapacity, 'number') | number:'.3-3'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{'Amount of waste retained on board (m3)' | translate}}" field="amountOfWasteRetainedOnBoard">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control name="amountOfWasteRetainedOnBoard" type="number" format="n3" [decimals]="3"
                [disableTooltip]="true" [(ngModel)]="dataItem.amountOfWasteRetainedOnBoard" [entity]="dataItem" property="amountOfWasteRetainedOnBoard"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{defaultDisplayValue(dataItem.amountOfWasteRetainedOnBoard, 'number') | number:'.3-3'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{'Port remaining waste will be delivered' | translate}}" [width]="200" field="remainingWasteDeliveryPortId">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control type="codelist" codelist="Location" [disableTooltip]="true"
                [(ngModel)]="dataItem.remainingWasteDeliveryPortId" [entity]="dataItem" property="remainingWasteDeliveryPortId"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.remainingWasteDeliveryPortId | codelist:'Location' | async}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{'Estimate amount to be generated till next port (m3)' | translate}}" field="estimatedGeneratedWaste">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <app-control name="estimatedGeneratedWaste" type="number" format="n3" [decimals]="3"
                [disableTooltip]="true" [(ngModel)]="dataItem.estimatedGeneratedWaste" [entity]="dataItem" property="estimatedGeneratedWaste"></app-control>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{defaultDisplayValue(dataItem.estimatedGeneratedWaste, 'number') | number:'.3-3'}}
        </ng-template>
    </kendo-grid-column>
</app-editable-grid>